import { ReactNode } from 'react';
import { ContractsTableProps } from '@spendbrain/modules/vendors/components/Contracts/ContractsTable/ContractsTable';
import { create } from 'zustand';

export enum DialogScreen {
  VendorContracts = 'vendor-contracts',
}

export type DialogScreenOpenedElement = {
  component: DialogScreen.VendorContracts;
  componentProps: ContractsTableProps;
} & {
  onClose?: () => void;
  dialogTitle: ReactNode;
  DialogContentProps?: React.HTMLAttributes<HTMLDivElement>;
};

interface DialogStoreActions {
  open: (opened: DialogScreenOpenedElement) => void;
  close: () => void;
  setClosable: (closable: boolean) => void;
}

interface DialogStoreValues {
  opened: DialogScreenOpenedElement | null;
  closable: boolean;
}

interface DialogStore extends DialogStoreValues, DialogStoreActions {}

export const useDialogStore = create<DialogStore>(set => ({
  opened: null,
  closable: true,
  open: opened => set({ opened }),
  close: () => set({ opened: null }),
  setClosable: closable => set({ closable: closable }),
  componentProps: {},
}));
